export function createCodegenErrorExtension(getErrorStepId, getWarningStepIds = () => []) {
  return {
    id: "codegenError",
    createForStep(_parentElement, view, stepContext) {
      return {
        update() {
          const stepId = stepContext.step.id;
          const errorStepId = getErrorStepId();
          const warningIds = getWarningStepIds() ?? [];

          view.g.classList.remove("sqd-step-codegen-error", "sqd-step-codegen-warning");

          if (errorStepId && errorStepId === stepId) {
            view.g.classList.add("sqd-step-codegen-error");
          } else if (warningIds.includes(stepId)) {
            view.g.classList.add("sqd-step-codegen-warning");
          }

          return null;
        },
        resolveClick() {
          return null;
        },
      };
    },
    createStartValue() {
      return null;
    },
  };
}
